const MEGA_BYTE = 1024 * 1024;

export const IMAGE_UPLOAD_MAX_FILE_SIZE_BYTES = 10 * MEGA_BYTE;

export const IMAGE_UPLOAD_TYPES = ['image/png', 'image/jpeg', 'image/bmp', 'image/gif'];

export const IMAGE_UPLOAD_ACCEPT = IMAGE_UPLOAD_TYPES.join(',');

export const IMAGE_UPLOAD_MAX_FILE_SIZE_MB = IMAGE_UPLOAD_MAX_FILE_SIZE_BYTES / MEGA_BYTE;

export const isAllowedImageType = (file: File): boolean => IMAGE_UPLOAD_TYPES.includes(file.type);

export const isWithinImageSizeLimit = (file: File): boolean => file.size <= IMAGE_UPLOAD_MAX_FILE_SIZE_BYTES;
